module.exports = __webpack_public_path__ + "static/stripes_two-369b53cb8dd808d1b989c3bcc6f14862.png";